import { Account } from './Account'
import { License } from './License'

export enum AccountViewType {
  Basic = 'BASIC',
  ExtendedWithLicenses = 'EXTENDED_WITH_LICENSES',
  Detailed = 'DETAILED',
}

export interface BasicAccount {
  account: Account
}

export interface CustomerAccountWithLicenses extends BasicAccount {
  licenses: License[]
}
